const authLayoutRoutes = {};

export default authLayoutRoutes;
